import { del, get, post, put } from "@/api/common/request";

// /users/search/interviewer
export const searchInterviewers = (params) => get("/users/search/interviewer", params || {});

// /users/interviewer/list
// 入参：page_num、page_size、query
export const listInterviewers = (params = {}) => get("/users/interviewer/list", params);

// /users/interviewer/add
// 入参：name、phone、email、status
export const addInterviewer = (params = {}) => post("/users/interviewer/add", params);

// /users/interviewer/edit
// 入参：userid、phone、email
export const editInterviewer = (params = {}) => put("/users/interviewer/edit", params);

// /users/interviewer/remove
// 入参：userid
export const removeInterviewer = (params = {}) => del("/users/interviewer/remove", params);

// /oa/search/oaUser
// 入参：query（默认可传 "00" 获取初始下拉）
export const searchOaUsers = (params = {}) => get("/oa/search/oaUser", params);

